module.exports = "/assets/mobile-apps/ios-app.png?iXo+G5z";